module.exports = __webpack_public_path__ + "img/right.c0bc2803.png";